export const CRUD_UPDATE = 'EPIC/CRUD_UPDATE';
export const CRUD_UPDATE_FAILURE = 'EPIC/CRUD_UPDATE_FAILURE';
export const CRUD_UPDATE_SUCCESS = 'APIC/CRUD_UPDATE_SUCCESS';
